/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AkceReklamaceE {
    Detail = 'DETAIL',
    DokoncitReseni = 'DOKONCIT_RESENI',
    Zamitnout = 'ZAMITNOUT',
    Schvalit = 'SCHVALIT',
    EditovatPlatnostDo = 'EDITOVAT_PLATNOST_DO',
    ReklamovatChybejiciOpravneni = 'REKLAMOVAT_CHYBEJICI_OPRAVNENI',
    VratitReklamaci = 'VRATIT_REKLAMACI',
    ZpochybnitUdaje = 'ZPOCHYBNIT_UDAJE',
    ZahajitReseni = 'ZAHAJIT_RESENI',
    PriraditResitele = 'PRIRADIT_RESITELE'
}

